const sharedPhotosPath = 'support-section'

export const getSupportPhotoUrl = (photosPath: string | null, file: string) =>
  `/static/${photosPath ?? sharedPhotosPath}/${file}`
